// "Review public holidays" acknowledgment. A fresh tenant already has its country's
// public-holiday pack seeded, so the setup step must NOT auto-complete just because
// holidays exist — it completes only once the admin has actually opened/reviewed the
// Holidays page. We persist that acknowledgment per-tenant in localStorage.
import { getCurrentTenant } from '@/lib/hrApi';

const keyFor = (tenantId: string) => `kp_holidays_reviewed_${tenantId}`;

async function currentTenantId(): Promise<string | null> {
  try {
    const t: any = await getCurrentTenant();
    return t?.id || t?.tenantId || t?._id || null;
  } catch {
    return null;
  }
}

export async function markHolidaysReviewed(): Promise<void> {
  const id = await currentTenantId();
  if (id) {
    try {
      localStorage.setItem(keyFor(id), '1');
    } catch {
      /* storage unavailable — non-fatal */
    }
  }
}

export async function holidaysReviewed(): Promise<boolean> {
  const id = await currentTenantId();
  if (!id) return false;
  try {
    return localStorage.getItem(keyFor(id)) === '1';
  } catch {
    return false;
  }
}
